export default __webpack_public_path__ + "static/media/britePingLogoLeftDots.2e144514.svg";